import { VCard } from 'vuetify/lib/components/VCard';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCard,{staticClass:"cardBorderStyle",attrs:{"flat":""}},[_c('div',{ref:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }